module.exports = __webpack_public_path__ + "img/OP BUILDER.c8f542e9.png";